import styled from 'styled-components';
import { fadeIn, fadeOut, slideIn, slideOut, scaleIn, scaleOut } from './selectionAnimations';

const ANIM_DURATION = '250ms';
const ANIM_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

const TreeWrapper = styled.div`
  .bp4-tree-node-secondary-label {
    font-size: 11px;
    color: #5c7080;
    padding-right: 8px;
  }

  .bp4-tree-node-content {
    height: 24px;
    border-radius: 6px;
    font-size: 12px;
  }

  .bp4-tree-node-content-0 {
    min-height: 24px;
    font-size: 12px;
    font-weight: 500;
  }

  // Specific styles for metric and dimension nodes, do not bold top level items as they are not expandable
  .metric {
    .bp4-tree-node-content-0 {
      font-weight: 300;
    }
  }

  .dimension {
    .bp4-tree-node-content-0 {
      font-weight: 300;
    }
  }

  .bp4-tree-node-content-1 {
    padding-left: 12px;
  }

  .bp4-tree-node-content-2 {
    padding-left: 16px;
  }
  .bp4-tree-node-content-3 {
    padding-left: 24px;
  }
  .bp4-tree-node-content-4 {
    padding-left: 32px;
  }
  .bp4-tree-node-content-5 {
    padding-left: 40px;
  }
  .bp4-tree-node-content-6 {
    padding-left: 48px;
  }

  .bp4-tree-node-expanded {
    .bp4-tree-node-content-0 {
      font-weight: 600;
    }
  }

  .bp4-tree-node {
    cursor: pointer;
    border-radius: 6px;
    border: 1px solid transparent;

    .bp4-tree-node-caret-none {
      min-width: 8px;
    }

    /* Show favorite star on hover or keyboard focus */
    .bp4-tree-node-secondary-label button {
      width: 0;
      overflow: hidden;
      opacity: 0;
      transition:
        width 0.15s ease,
        opacity 0.15s ease;
    }

    &:hover .bp4-tree-node-secondary-label button,
    &:focus-within .bp4-tree-node-secondary-label button {
      width: 16px;
      opacity: 1;
    }
  }

  /* Selection animation classes */
  .bp4-tree-node.ude-entering-fade > .bp4-tree-node-content {
    animation: ${fadeIn} ${ANIM_DURATION} ${ANIM_EASING} both;
  }
  .bp4-tree-node.ude-exiting-fade > .bp4-tree-node-content {
    animation: ${fadeOut} ${ANIM_DURATION} ${ANIM_EASING} forwards;
  }
  .bp4-tree-node.ude-entering-slide > .bp4-tree-node-content {
    animation: ${slideIn} ${ANIM_DURATION} ${ANIM_EASING} both;
  }
  .bp4-tree-node.ude-exiting-slide > .bp4-tree-node-content {
    animation: ${slideOut} ${ANIM_DURATION} ${ANIM_EASING} forwards;
  }
  .bp4-tree-node.ude-entering-scale > .bp4-tree-node-content {
    animation: ${scaleIn} ${ANIM_DURATION} ${ANIM_EASING} both;
  }
  .bp4-tree-node.ude-exiting-scale > .bp4-tree-node-content {
    animation: ${scaleOut} ${ANIM_DURATION} ${ANIM_EASING} forwards;
  }
`;

export default TreeWrapper;
